import { status } from '../../config.ts'
import { categoriesPage1, categoryDetail } from './data.ts'
import { wait } from '@/__mocks__/util/async.ts'

export default [
  {
    method: 'GET',
    path: '/categories?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, categoriesPage1]
    }
  },
  {
    method: 'GET',
    path: '/categories/1',
    reply: async () => {
      await wait()
      return [status.ok, categoryDetail]
    }
  },
  {
    method: 'POST',
    path: '/categories',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'PATCH',
    path: '/categories/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'DELETE',
    path: '/categories/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  }
]
